
import { defineComponent, PropType, ref } from 'vue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import JrDateMultiPicker from '@/components/jr-parts/JrDateMultiPicker.vue'

/**
 * 日付複数選択ボタンコンポーネント
 */
export default defineComponent({
  name: 'JrDateRangePickerButton',
  emits: ['update:modelValue'],
  components: {
    JrButton,
    JrDateMultiPicker,
  },
  props: {
    modelValue: {
      // 文字列の日付配列
      type: Array as PropType<string[]>,
      required: false,
      default: null,
    },
    buttonType: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      required: false,
      default: 'YYYY年MM月DD日',
    },
    disabledDate: {
      type: Function,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    const pickerRef = ref<InstanceType<typeof JrDateMultiPicker>>()
    return {
      pickerRef,
      focus: () => {
        if (pickerRef.value) {
          pickerRef.value.focus()
        }
      },
      update: (dates: string[]) => {
        context.emit('update:modelValue', dates)
      },
    }
  },
})
